import useAbilityAccess from './useAbilityAccess'

/**
 * Whether the current user may edit a service user's *general* (non-sensitive)
 * data — used as the wholesale enable/disable gate for the resident profile
 * edit forms (Personal Information, Care Information).
 *
 * CASL field-level rules are unioned, so there is no single ability that means
 * "can edit anything non-sensitive". We therefore probe a representative core
 * field (`dateOfBirth`) as a proxy:
 *   - Admin / Management hold unrestricted `update Resident` → passes.
 *   - The "Service User Management" add-on grants every editable field except
 *     the sensitive ones (DNACPR, status) → passes, so add-on users keep full
 *     access to the general forms while the sensitive inputs are gated
 *     individually (see the DNACPR card and the status control).
 *   - Baseline limited roles (e.g. Senior Carer: picture/address/fundingSource
 *     only) do not hold it → the forms stay read-only, exactly as today.
 *
 * NOTE: the proxy relies on `dateOfBirth` remaining in the add-on's Resident
 * fields allowlist (see CM-3584). It is a core editable field, so this holds.
 */
const useCanEditServiceUserData = (): boolean =>
  useAbilityAccess([{ i: 'update', this: 'Resident', field: 'dateOfBirth' }])

export default useCanEditServiceUserData
